export const tags = {
  account: 'account',
  accountBenefit: 'accountBenefit',
  accountMeta: 'accountMeta',
  addressVerification: 'addresVerification',
  application: 'application',
  applicationMeta: 'applicationMeta',
  benefit: 'benefit',
  bvAppeal: 'bvAppeal',
  bvLog: 'bvLog',
  connectionRequest: 'connectionRequest',
  dvAppeal: 'dvAppeal',
  dvLog: 'dvLog',
  emailVerification: 'emailVerification',
  expert: 'expert',
  invitation: 'invitation',
  language: 'language',
  level: 'level',
  levelup: 'levelup',
  metadata: 'metadata',
  phoneVerification: 'phoneVerification',
  redeemedBenefit: 'redeemedBenefit',
  sasUri: 'sasUri',
  user: 'user',
  userDetail: 'userDetail',
  userToken: 'userToken',
  connectionFeedback: 'connectionFeedback',
  ataRequest: 'ataRequest',
  azureCategory: 'azureCategory',
  userCategory: 'userCategory',
  airsConsumption: 'airsConsumption',
};

export type Tag = (typeof tags)[keyof typeof tags];
